import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import {Link} from "react-router-dom";

@inject('ticketStore')
@observer
export default class ReservationTicketItem extends Component {

    constructor(props) {
        super(props);

        this.renderReservationButton = this.renderReservationButton.bind(this);
    }

    //주문 상태는 사용가능 혹은 다른 이유로 티켓을 사용할 수 없을 경우 나오는 메세지 출력
    renderTicketStatusMessage = (ticketMessage) => {
        return (
            <div className="desc-state desc-disabled" dangerouslySetInnerHTML={ {__html: ticketMessage} } />
        )
    }

    renderOrderStateName = (orderState, orderStateNm, ticketUsable, ticketMessage) => {

        // //사용완료
        if (orderState === 'A') {
            return (
                <span className="txt-state txt-used">{orderStateNm}</span>
            )
        }

        if (orderState !== 'A' && orderState !== 'E') {
            return (
                <span className="txt-state txt-fail">{orderStateNm}</span>
            )
        }

        //사용가능
        if (orderState === 'E') {
            if(ticketUsable) {
                return (
                    <span className="txt-state txt-use">{orderStateNm}</span>
                )
            }

            return (
                <div className="box-state">
                    <span className="txt-state txt-disabled">{orderStateNm}</span>
                    {this.renderTicketStatusMessage(ticketMessage)}
                </div>
            )
        }
    };

    renderReservationButton(orderState, ticketUsable, barcode, pin) {
        switch(orderState) {
            case 'A':
                if(!barcode || !pin) { return null; }
                return(
                  <Link to={{
                      pathname: `/result/${barcode}/reserve/${pin}`,
                      state: {
                          barcode,
                          pin
                      }
                  }} style={{ textDecoration: 'none' }}><span>예약조회</span></Link>
                )
            case 'E':
                if(!barcode || !pin) { return null; }
                if(!ticketUsable) {
                    return(
                      <Link to={{
                          pathname: `/result/${barcode}/reserve/${pin}`,
                          state: {
                              barcode,
                              pin
                          }
                      }} style={{ textDecoration: 'none' }}><span>예약조회</span></Link>
                    )
                }
                return(
                    <Link to={{
                        pathname: `/reserve/${barcode}/pin/${pin}`,
                        state: {
                            barcode,
                            pin
                        }
                    }} style={{ textDecoration: 'none' }}><span>예약하기</span></Link>
                );
            default:
        }
    }

    render() {
        const {
            item: {
                itemNm,
                pin,
                orderState,
                orderStateNm,
                ticketStatus: {
                    usable: ticketUsable,
                    message: ticketMessage,
                }
            },
            barcode
        } = this.props;

        return (
            <div className="item-content">
                <label>
                    <span className="icon-chk"></span>
                    <span className="txt-chk">{itemNm}</span>
                    <span className="txt-pincode">핀번호 : {pin}</span>
                    {this.renderOrderStateName(orderState, orderStateNm, ticketUsable, ticketMessage)}
                </label>
                <div style={{
                    textAlign: 'center',
                    color: '#a8a8a8',
                    fontWeight: 'bold',
                    marginTop: '20px',
                    marginBottom: '20px',
                    paddingTop: '20px',
                    paddingBottom: '20px',
                    borderBottom: '1px solid #d8d8d8',
                    borderTop: '1px solid #d8d8d8'
                }}>{this.renderReservationButton(orderState, ticketUsable, barcode, pin)}</div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ReservationTicketItem.jsx